import { Injectable } from '@angular/core';
import * as postal from 'postal';

@Injectable()
export class MessagingService {
    private channel: IChannelDefinition<any>;

    constructor() {
        this.channel = postal.channel();
    }

    subscribe<T>(topic: string, callback: (message: T) => void): ISubscription {
        return this.channel.subscribe(topic, callback);
    }

    publish(topic: string, message) {
        this.channel.publish(topic, message);
    }
}

export interface ISubscription {
    unsubscribe();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/messaging/messaging.service.ts